import { useEffect } from 'react';

import type { UseEditClientServiceEffectsProps } from '@pages/Clients/EditClientService/types';

export const useEditClientServiceEffects = ({
  initTabHandler,
  fetchClientService,
}: UseEditClientServiceEffectsProps) => {
  useEffect(() => {
    initTabHandler();
  }, [initTabHandler]);

  useEffect(() => {
    fetchClientService();
  }, [fetchClientService]);
};
